// Everyone's profile photo, keyed by person id: loaded once by the shell and
// read by every avatar, so a photo set on My Info shows wherever that person does.
import { useSyncExternalStore } from 'react';
import api from './useApi';

let photos = {};
let loaded = null;
const listeners = new Set();
const emit = () => listeners.forEach(l => l());
const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };

export function loadPhotos() {
  // No photos is not an error worth showing: every avatar falls back to initials.
  loaded ||= api.get('people/photos').then(p => { photos = { ...p, ...photos }; emit(); }).catch(() => {});
  return loaded;
}

/** A photo just saved, so it shows at once rather than on the next page load. */
export function setPhoto(id, url) {
  photos = { ...photos, [id]: url || undefined };
  emit();
}

export default function usePhotos() {
  return useSyncExternalStore(subscribe, () => photos);
}
